const protocol  = 'https://';
const rootURI = 'creditkey.com';

export default function backend(api = true) {
  if (process.env && process.env.NODE_ENV !== 'production') return 'http://localhost:9100';

  let subDomain = 'www';
  if (window.location && window.location.hostname.match(/staging/i)) subDomain = 'staging';

  const baseURI = protocol + subDomain + '.' + rootURI;
  return api ? `${baseURI}/app` : baseURI;
}
